import React, { useState } from "react"

import {
  Container,
  Item,
  Key,
  Value,
  SeeAllSpecs,
  Arrow,
  Line,
  TextAndArrow, Items,
} from "./styles"

const Properties = ({ properties = [] }) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <Container>
      <Items>
        {properties.slice(0, 4).map((property) => (
          <Property key={property.id} property={property} />
        ))}
        {expanded &&
          properties.slice(4).map((property) => <Property key={property.id} property={property} />)}
      </Items>
      {properties.length > 4 && (
        <SeeAllSpecs>
          <Line />
          <TextAndArrow onClick={() => setExpanded((prev) => !prev)}>
            <span>See {expanded ? 'less' : 'all'} specs</span>
            <Arrow
              id="carousel-arrow"
              width={35}
              height={35}
              orientation={expanded ? "up" : "down"}
            />
          </TextAndArrow>
          <Line />
        </SeeAllSpecs>
      )}
    </Container>
  )
}

const Property = ({ property }) => (
  <Item>
    <Key>{property.key}</Key>
    <Value>{property.value}</Value>
  </Item>
)

export default Properties
